export default __webpack_public_path__ + "static/media/picto-close.48a4f6fb.svg";